import React from "react";
const IconMadeInUS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" {...props}>
    <path
      d="M20.2268 42.3954C20.2268 42.3954 24.0622 42.1819 28.2654 38.7192C32.4686 35.2565 33.6474 31.1372 33.6474 31.1372C34.5808 32.6243 35.7517 36.2466 34.4693 38.0202"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path d="M20.7744 48.7473H38.0871" stroke="currentColor" strokeWidth="2" />
    <path d="M31.4819 31.5551L31.4819 27.7627" stroke="currentColor" strokeWidth="2" />
    <path
      d="M19.2578 22.2435L18.2529 13.8893H21.2675L20.2626 22.2435H19.2578Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M20.7696 21.2567L22.5943 28.0388L19.7983 29.4656L18.3498 22.7023L19.0159 20.3239L20.7696 21.2567Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M19.6786 12.8353H19.6469C18.6923 12.7622 18.0647 12.3357 17.8115 11.5925C17.2208 9.99634 18.9297 7.54729 19.2778 7.07819C19.3273 7.01026 19.389 6.95566 19.4587 6.9182C19.5284 6.88074 19.6044 6.86133 19.6812 6.86133C19.7581 6.86133 19.834 6.88074 19.9037 6.9182C19.9734 6.95566 20.0352 7.01026 20.0847 7.07819C20.4328 7.54729 22.1416 9.99634 21.5509 11.6169C21.2872 12.3357 20.6701 12.7378 19.7155 12.8353H19.6786Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M25.248 25.3362C25.248 27.2605 26.808 28.8204 28.7323 28.8204V28.8204C30.6565 28.8204 32.2165 27.2605 32.2165 25.3362V22.5736H28.7323H25.248V25.3362Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <path
      d="M32.2158 22.5739C32.2158 22.5739 31.5886 19.8167 28.7316 19.8167C25.8747 19.8167 25.2474 22.5739 25.2474 22.5739"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <path
      d="M24.8979 23.6604L20.4229 21.1096L25.3174 20.8874L23.4759 15.6725L27.4907 19.5202L28.7035 13.9999L29.8745 19.5202L34.0984 16.0912L32.0073 21.1096H37.3399L32.4256 23.6604"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <rect
      x="34.8882"
      y="37.2787"
      width="6.60035"
      height="8.66449"
      transform="rotate(29.1666 34.8882 37.2787)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M18.2535 30.5755L17.7535 29.7095L17.4035 31.1023L18.2535 30.5755ZM23.9696 27.2753L24.7772 26.6857L23.4696 26.4093L23.9696 27.2753ZM27.0123 31.4431L26.2047 32.0328L27.0123 32.4431L27.0123 31.4431ZM19.0141 48.644L18.025 48.4971L18.8569 49.6315L19.0141 48.644ZM34.5354 31.4431L35.1868 30.6844L34.5354 30.4431L34.5354 31.4431ZM21.0314 35.0577L22.0206 35.2046L21.8814 34.5309L21.0314 35.0577ZM31.7218 44.5826L32.3612 43.8138L30.8235 42.535L30.1841 43.3039L31.7218 44.5826ZM18.7535 31.4415L24.4696 28.1414L23.4696 26.4093L17.7535 29.7095L18.7535 31.4415ZM23.1619 27.865L26.2047 32.0328L27.82 30.8535L24.7772 26.6857L23.1619 27.865ZM27.0123 32.4431L34.5354 32.4431L34.5354 30.4431L27.0123 30.4431L27.0123 32.4431ZM20.0033 48.7909L22.0206 35.2046L20.0423 34.9108L18.025 48.4971L20.0033 48.7909ZM21.8814 34.5309L19.1035 30.0487L17.4035 31.1023L20.1815 35.5845L21.8814 34.5309ZM33.8841 32.2019C34.93 33.0999 35.881 33.8964 36.5035 34.927C37.0876 35.8942 37.4036 37.1156 36.9934 38.9063L38.9429 39.3529C39.4655 37.0717 39.0757 35.3174 38.2155 33.8931C37.3937 32.5323 36.1619 31.5215 35.1868 30.6844L33.8841 32.2019ZM18.8569 49.6315C20.6004 49.9091 23.0247 49.5737 25.355 48.7473C27.6965 47.9169 30.0965 46.5372 31.7218 44.5826L30.1841 43.3039C28.8617 44.894 26.8158 46.1072 24.6865 46.8623C22.5461 47.6214 20.4748 47.8639 19.1714 47.6564L18.8569 49.6315Z"
      fill="currentColor"
    />
  </svg>
);
export default IconMadeInUS;
